import React, { useEffect, useState } from 'react';
import { Menu } from 'lucide-react';
import { useContent } from '../contexts/ContentContext';
import { pageTitle, pages, resolvePage } from '../pages';
import Modal from './Modal';
import ThemeSwitcher from './ThemeSwitcher';
import LanguageSwitcher from './LanguageSwitcher';

const SiteMap: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { content, language, t } = useContent();
    const route = resolvePage(window.location.search);
    const currentUrl = window.location.search;
    useEffect(() => setIsOpen(false), [currentUrl]);
    return <>
        <button type="button" className="lab-menu-button" aria-label={t('common.menu')} aria-expanded={isOpen} onClick={() => setIsOpen(true)}>
            <Menu size={20} aria-hidden="true" /><span>{t('common.menuLabel')}</span>
        </button>
        <Modal helpSection="menu" isOpen={isOpen} onClose={() => setIsOpen(false)} title={t('common.menu')} manageFocus panelClassName="lab-menu-panel">
            <nav aria-label={t('common.menu')} className="lab-menu-links">
                {pages.filter(page => !['word', 'color', 'search', 'workflow', 'ratings'].includes(page.id)).map(page => <a key={page.id} href={page.href} onClick={() => setIsOpen(false)} aria-current={route.definition.id === page.id ? 'page' : undefined}>{pageTitle(page, content, language, t)}</a>)}
            </nav>
            <div className="lab-settings"><LanguageSwitcher /><span>{t('common.languageName')}</span><ThemeSwitcher /></div>
        </Modal>
    </>;
};
export default SiteMap;
